<template>
    <div>
        <template v-if="manyChunks">
            <v-lazy
                    v-for="chunk in chunks"
                    :key="chunk.key"
                    v-model="chunk.visible"
                    min-height="200"
                    min-width="100%"
                    :options="{threshold:0}"
                    transition="none"
            >
                <slot v-bind="chunk.items"></slot>
            </v-lazy>
        </template>
        <template v-else>
            <slot v-bind="value"></slot>
        </template>
    </div>
</template>

<script>
    import _ from 'lodash';

    export default {
        name: "LargeLazyList",
        props: {
            value: {
                type: Array
            },
            chunkSize: {
                default: 48
            }
        },
        data: function() {
            return {
                version: 0
            }
        },
        computed: {
            chunks: function () {
                return _.map(
                    _.chunk(this.value, this.chunkSize),
                    (items, index) => {
                        return {
                            key: this.generateChunkKey(index),
                            visible: (index===0),
                            items: items
                        }
                    }
                );
            },
            manyChunks: function () {
                return this.value.length>this.chunkSize
            }
        },
        watch: {
            value: function() {
                this.version++;
            }
        },
        methods: {
            generateChunkKey: function (index) {
                return index ? [this.version, index].join('-') : index;
            }
        }
    }
</script>
